import { type MonetaryValue } from 'ezmoney';
import React from 'react';

import {
  type ExpenseBill,
  type InvoiceBill,
} from 'src/core/modules/invoices/models';

import WireTransferControllerModal from './WireTransferControllerModal';

type Props = {
  selectedPayments: Array<{
    id: string;
    bill: InvoiceBill | ExpenseBill | undefined;
    amount: MonetaryValue;
  }>;
  isSendingToPayment: boolean;
  isOpen: boolean;
  showNotEnoughFundsWarning: boolean;
  onClose: () => void;
  onSendToPayment: (options?: { onSuccess: () => void }) => void;
  onComplete: () => void;
};

const WireTransferModal = ({
  selectedPayments,
  isSendingToPayment,
  isOpen,
  showNotEnoughFundsWarning,
  onClose,
  onSendToPayment,
  onComplete,
}: Props) => {
  return (
    <WireTransferControllerModal
      selectedPayments={selectedPayments}
      showNotEnoughFundsWarning={showNotEnoughFundsWarning}
      isSendingToPayment={isSendingToPayment}
      isOpen={isOpen}
      onClose={onClose}
      onSendToPayment={onSendToPayment}
      onComplete={onComplete}
    />
  );
};

export default WireTransferModal;
